// DECIMAL permanece texto: não converter dinheiro bancário para Number.
export function moedaRetorno(valor) {
    if (valor === null || valor === undefined || valor === '') return 'Não informado';
    const m = String(valor).match(/^(-?)(\d+)(?:\.(\d{1,2}))?$/);
    if (!m) return 'Valor inválido';
    return `${m[1]}R$ ${m[2].replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${(m[3] || '').padEnd(2, '0')}`;
}
export function dataRetorno(valor) {
    const m = String(valor || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return m ? `${m[3]}/${m[2]}/${m[1]}` : 'Não informada';
}
export const rotuloRetorno = valor => ({
    pendente: 'Pendente', nao_localizado: 'Não localizado', ambiguo: 'Ambíguo', vinculado: 'Vinculado',
    nao_aplicavel: 'Não aplicável', sem_indicio: 'Sem indício', suspeita: 'Suspeita', confirmada: 'Confirmada',
    distinta: 'Distinta', nao_analisada: 'Não analisada', importado: 'Importado',
}[valor] || valor || 'Não informado');
